<template>
  <v-select
    :model-value="environmentStore.currentEnvironment"
    :items="environmentStore.environments"
    item-title="name"
    item-value="id"
    label="Environment"
    return-object
    hide-details
    variant="outlined"
    density="compact"
    :loading="loading"
    max-width="200"
    @update:model-value="environmentStore.setCurrentEnvironment($event)"
  />
</template>

<script lang="ts">
import { computed, defineComponent, watch } from 'vue'

import { useApiStore } from '@/stores/api'
import { useEnvironmentStore } from '@/stores/environment'

export default defineComponent({
  name: 'EnvironmentSelect',

  setup () {
    const apiStore = useApiStore()
    const environmentStore = useEnvironmentStore()
    watch(() => apiStore.loggedIn, async (loggedIn) => {
      if (!loggedIn || environmentStore.environments.length) return
      await environmentStore.loadEnvironments()
    }, { immediate: true })

    const loading = computed(() => {
      return !environmentStore.environments.length
    })

    return {
      environmentStore,
      loading,
    }
  },
})
</script>
